<a-tag class="text-sm text-left">{{eventFormattedDate}}</a-tag>